import React, { memo } from "react";
import { StyledVerticalNavigation } from "./styled";
import { IVerticalNavigationProps } from "./types";
import VerticalNavigationItemsList from "./VerticalNavigationItemsList";

export const VerticalNavigation = ({
    items,
    selectedItemID,
    onChangeSelectedItem,
    content,
}: IVerticalNavigationProps) => {
    return (
        <StyledVerticalNavigation>
            <VerticalNavigationItemsList
                items={items}
                selectedItemID={selectedItemID}
                onChangeSelectedItem={onChangeSelectedItem}
            />
            <div className="content">{content}</div>
        </StyledVerticalNavigation>
    );
};

export default memo(VerticalNavigation);
